import { useDispatch, useSelector } from "react-redux";
import { IRootReducer } from "store/reducers";
import { ClearCompany, setCompany } from "./company.action";
import { ICompanyState } from "./company.interface";

export interface ICompanyModel extends ICompanyState{
  set: (company: ICompanyState) => void;
  clear: Function;
}

export default function UserModel(){
  const company = useSelector<IRootReducer,ICompanyState>(state => state.company);
  const dispatch = useDispatch();

  const _retorno:ICompanyModel = {...company,...{
    set:(company: ICompanyState)=>{dispatch(setCompany(company))},
    clear:()=>{dispatch(ClearCompany())},
  }};

  return _retorno;
}